import React, { useState } from 'react';
import axios from 'axios';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { toast } from 'sonner';
import { Eye, EyeOff, Lock } from 'lucide-react';

const API = `${(typeof window !== 'undefined' && window.location?.origin) || process.env.REACT_APP_BACKEND_URL}/api`;

const Login = ({ onLogin }) => {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const { data } = await axios.post(`${API}/admin/login`, { password });
      sessionStorage.setItem('admin_token', data.token);
      toast.success('Connexion réussie');
      onLogin(data.token);
    } catch (err) {
      toast.error(err.response?.status === 401 ? 'Mot de passe incorrect' : 'Erreur de connexion');
      setPassword('');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-100 to-slate-200 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <div className="bg-[#FAF6EE] p-3 rounded-full">
              <Lock className="h-8 w-8 text-[#C2A36B]" />
            </div>
          </div>
          <CardTitle className="text-2xl font-bold text-slate-800">LOVELIA — IMMOBILIER NEUF</CardTitle>
          <CardDescription className="text-slate-600">Accès sécurisé - Administration</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="password">Mot de passe</Label>
              <div className="relative">
                <Input
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Entrez votre mot de passe"
                  className="pr-10"
                  required
                  autoFocus
                  data-testid="admin-password-input"
                />
                <Button
                  type="button"
                  variant="ghost"
                  size="sm"
                  className="absolute right-0 top-0 h-full px-3 py-2 hover:bg-transparent"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <EyeOff className="h-4 w-4 text-slate-400" /> : <Eye className="h-4 w-4 text-slate-400" />}
                </Button>
              </div>
            </div>
            <Button
              type="submit"
              className="w-full bg-[#0E1E34] hover:bg-[#0B1626] text-white"
              disabled={isLoading || !password}
              data-testid="admin-login-button"
            >
              {isLoading ? 'Connexion...' : 'Se connecter'}
            </Button>
          </form>
          <div className="mt-6 pt-4 border-t border-slate-200">
            <div className="text-xs text-slate-500 text-center space-y-1">
              <p><strong>LOVELIA — IMMOBILIER NEUF</strong></p>
              <p>www.lovelia-immo.fr</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Login;
